import { render, staticRenderFns } from "./Vessels.vue?vue&type=template&id=3299562b"
import script from "./Vessels.vue?vue&type=script&lang=js"
export * from "./Vessels.vue?vue&type=script&lang=js"
import style0 from "./Vessels.vue?vue&type=style&index=0&id=3299562b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports